import d3 from "d3";
import utilParties from "../modules/utilParties";

function getPercentage(top, value) {
  return (value * 100) / top;
}

function drawChart(selector, parties) {
  let top = parties.reduce(
    (max, party) => (party.votesPct > max ? party.votesPct : max),
    0
  );
  const elem = d3.select(document.getElementById(selector));
  let chart = d3.scale
    .linear()
    .domain([0, d3.max(parties.map((party) => party.votesPct))])
    .range([0, top]);

  if (parties[0].prevVotesPct >= 0) {
    const topPrev = parties.reduce(
      (max, party) => (party.prevVotesPct > max ? party.prevVotesPct : max),
      0
    );
    if (topPrev > top) {
      top = topPrev;
      chart = d3.scale
        .linear()
        .domain([0, d3.max(parties.map((party) => party.prevVotesPct))])
        .range([0, top]);
    }
  }

  elem.selectAll("div").remove();

  if (parties.length === 0) {
    elem
      .append("div")
      .attr("class", "c-module-horizontal__no-results")
      .text(window.ac_labels.percentage_of_votes.waiting_data);
  }

  elem
    .data(parties)
    .selectAll("div")
    .data(parties)
    .enter()
    .append("div")
    .attr("class", "c-module-horizontal__bar-wrapper");

  if (parties.length) {
    const container = elem
      .selectAll(".c-module-horizontal__bar-wrapper")
      .append("div")
      .attr("class", "c-module-horizontal__bar-container");

    container
      .append("span")
      .attr("class", "c-module-horizontal__bar-seats")
      .append("span")
      .attr("class", (d) => utilParties.getTendencyClass(d.increase))
      .append("span")
      .attr("class", "c-module-horizontal__bar-name")
      .attr("title", (d) => d.partyName)
      .text((d) => d.partyName);

    container
      .append("span")
      .attr("class", "c-module-horizontal__bar-votes")
      .text((d) => `${d.votes ? d.votes : "0"}`)
      .append("span")
      .attr("class", "c-module-horizontal__text")
      .text("votos");

    container
      .append("span")
      .attr("class", "c-module-horizontal__bar-votes")
      .text((d) => `${d.seats ? d.seats : "0"}`)
      .append("span")
      .attr("class", "c-module-horizontal__text")
      .text(`${window.ac_labels.tooltip.election}`);
  }

  //
  // container
  //   .append("span")
  //   .attr("class", "c-module-horizontal__bar-seats")
  //   .attr("class", (d) => utilParties.getTendencyClass(d))
  //   .text((d) => d.seats);

  elem
    .selectAll(".c-module-horizontal__bar-wrapper")
    .append("span")
    .attr("class", "c-module-horizontal__bar-number-block");

  elem
    .selectAll(
      ".c-module-horizontal__bar-wrapper .c-module-horizontal__bar-number-block"
    )
    .append("span")
    .attr("class", "c-module-horizontal__bar-number")
    .text((d) => `${d.votesPct > 0 ? d.votesPct.toFixed(2).replaceAll(".", ",") : "-"}%`);

  if (parties[0].prevVotesPct >= 0) {
    elem
      .selectAll(
        ".c-module-horizontal__bar-wrapper .c-module-horizontal__bar-number-block"
      )
      .append("span")
      .attr(
        "class",
        "c-module-horizontal__bar-number c-module-horizontal__bar-number--previous"
      )
      .text(
        (d) => `${d.prevVotesPct > 0 ? d.prevVotesPct.toFixed(2).replaceAll(".", ",") : "-"}%`
      );
  }

  elem
    .selectAll(".c-module-horizontal__bar-wrapper")
    .append("div")
    .attr("class", "c-module-horizontal__bar");

  elem
    .selectAll(".c-module-horizontal__bar")
    .append("span")
    .attr("class", (d) => `c-module-horizontal__bar-bg ${d.partyCode}`);

  if (parties[0].prevVotesPct >= 0) {
    elem
      .select(".c-module-horizontal__bar-wrapper")
      .append("span")
      .attr("class", "c-module-horizontal__years");

    elem
      .select(".c-module-horizontal__bar-wrapper .c-module-horizontal__years")
      .append("span")
      .attr("class", "c-module-horizontal__year")
      .text(`${elem[0][0].dataset.electionCurrent}`);

    elem
      .select(".c-module-horizontal__bar-wrapper .c-module-horizontal__years")
      .append("span")
      .attr({
        class: "c-module-horizontal__year c-module-horizontal__year--previous",
        ...(window.ac_election === 'autonomic' && window.ac_region_level === 'index' && {
          'data-tooltip': window.ac_labels.percentage_of_votes.previous_note
        }),
      })
      .text(`${elem[0][0].dataset.electionPrevious}`);
  }

  if (parties[0].prevVotesPct >= 0) {
    elem
      .selectAll(".c-module-horizontal__bar")
      .append("span")
      .attr(
        "class",
        (d) => `c-module-horizontal__bar-bg c-module-horizontal__bar-bg--previous ${d.partyCode}`
      );
  }

  setTimeout(() => {
    elem
      .selectAll(".c-module-horizontal__bar span")
      .style("width", (d) => `${chart(getPercentage(top, d.votesPct))}%`);
    if (parties[0].prevVotesPct >= 0) {
      elem
        .selectAll(
          ".c-module-horizontal__bar .c-module-horizontal__bar-bg--previous"
        )
        .style(
          "width",
          (d) => `${chart(getPercentage(top, d.prevVotesPct))}%`
        );
    }
  }, 0);
}


function init(selector, parties) {
  if (document.getElementById(selector)) {
    drawChart(selector, parties);
  }
}

module.exports = {
  init,
};
